import { render, staticRenderFns } from "./BookingDetailsGuestsModal.vue?vue&type=template&id=6f37ba06"
import script from "./BookingDetailsGuestsModal.vue?vue&type=script&lang=js"
export * from "./BookingDetailsGuestsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports